import Action from "./action";
import View from "./view";
import {openModal, closeModal, slideCalendar, scrollWindow, flickCal} from "../modules/animation";
import store from "./store";

const events = store.events;

store.$eventhub
	// DOM -> Action (-> state)
	.on("ready", store, Action.init)
	.on("click", ".forcia-go-detail", store, Action.goDetail)
	.on("click", ".forcia-go-detail-calendar", store, Action.goDetailCalendar)
	.on("click", ".forcia-state", store, Action.setState)
	.on("click", ".forcia-keyword-submit", store, Action.searchKeyword)
	.on("click", ".forcia-open-course-calendar", store, Action.openCourseCalendar)
	// state -> view
	.on(events("init"), store, View.dataVersion)
	.on(events("Count"), store, View.allCount)
	.on(events("Count"), store, View.pager)
	.on(events("Count"), store, View.deptLayer)
	.on(events("Count"), store, View.destLayer)
	.on(events("isOpenedDeptLayer"), store, View.openDeptLayer)
	.on(events("isOpenedDestLayer"), store, View.openDestLayer)
	.on(events("openedRegion"), store, View.openRegion)
	.on(events("courseCalendarLayer"), store, View.courseCalendar)
	// Other events without state
	.on("click", ".forcia-open-modal", openModal)
	.on("click", ".modal_wrap", closeModal)
	.on("click", ".forcia-scroll", scrollWindow)
	.on("click", "#forcia-course-calendar .ipt_calBox_navItem a", slideCalendar)
	// enable flick
	.on(flickCal.events, ".ipt_calBox")
	.on("myflickprev", ".ipt_calBox", flickCal.prev)
	.on("myflicknext", ".ipt_calBox", flickCal.next)
	;



// WEBPACK FOOTER //
// ./web/WEB-INF/js/client/landing/index.js